import { Box, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function BackButton({width}) {
  const navigate = useNavigate()
  return (
    <Box width={width}>
      <Button style={{ width: 80, height: 20, fontSize: 10, fontWeight: 400, borderRadius: 25, backgroundColor: " rgba(211, 211, 211, 0.4)", color: "black", }} onClick={() => navigate(-1)}><span>←</span> Back
      </Button>
    </Box>
  )
}

export default BackButton
